import * as React from "react";
const SvgIconeye = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g
      stroke="#6C737F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M12.5 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" />
      <path d="M1.667 10.001C3 6.587 6.114 4.168 10 4.168c3.887 0 7 2.42 8.334 5.833C17 13.416 13.887 15.835 10 15.835c-3.886 0-7-2.42-8.333-5.834Z" />
    </g>
  </svg>
);
export default SvgIconeye;